jQuery(document).ready(function() {

    // Button up-Click [Start] //
    jQuery('#goup').click(function( event ) {

        event.preventDefault();
        jQuery('html, body').animate({scrollTop: 0}, 300);
        return false;

    }); // Button up-Click [End]) //
   
    // Windows scroll control - Start //
    var amountScrolled = 300;
    jQuery(window).scroll(function(){

        if ( jQuery(window).scrollTop() > amountScrolled ) {
            if (jQuery('.go-up').css("display")=="none") {
                jQuery('.go-up').fadeIn('fast');
            }
        } else { jQuery('.go-up').fadeOut('fast'); }

    }); // Windows scroll control - End] //
    
   

});
